import React, { useEffect } from "react";
import * as queryString from "query-string";
import moment from "moment-timezone";
import styled, { css } from "styled-components";

import { PageProps } from "src/pages/Router/routes";
import { Text } from "src/library/components/Text";
import {
  Layout,
  MainContentWrapper
} from "src/core/shared/components/Layout";
import { TabbedNavigation } from "src/library/components/TabbedNavigation";
import ApprovalChangeProductsTab from "src/modules/product-approval/components/ApprovalChangeProductsTab";
import ApprovalChangeDropsTab from "src/modules/product-approval/components/ApprovalChangeDropsTab";
import {
  useProductApprovalApi,
  ProductApprovalRequestName
} from "src/modules/product-approval/api/product-approval.api";

/**
 * Product approval changes page
 */
const ApprovalChangeDatesPage: React.ReactFCWithChildren<PageProps<unknown, {approvalListId: string}>> = props => {
  const currentApprovalListId = props.match && parseInt(props.match.params.approvalListId, 0);
  const [ getApprovalListRes, getApprovalListReq ] = useProductApprovalApi(ProductApprovalRequestName.GET_APPROVAL_LIST);
  const params = queryString.parse(props.location.search);

  // set the product approval list on mount
  useEffect(() => {
    if (currentApprovalListId) {
      getApprovalListReq({ id: currentApprovalListId });
    }
  }, [ currentApprovalListId, getApprovalListReq ]);

  return (
    <Layout
      {...props}
      title={`Approval List Changes - ${params.startDate ? moment.utc(params.startDate).format("ddd D MMM YYYY") : ""}`}
    >
      <MainContentWrapper fill>
        {getApprovalListRes.data && (
          <Text as="h4">
            {`Approval List: ${getApprovalListRes.data.name} ${getApprovalListRes.data.description ? " - " + getApprovalListRes.data.description : ""}`}
          </Text>
        )}

        <TabbedTableWrapper>
          {currentApprovalListId && (
            <TabbedNavigation
              defaultTab="products"
              className="tab-navigator"
              tabs={[
                {
                  title: "Products",
                  name: "products",
                  content: () => (
                    <ApprovalChangeProductsTab
                      {...props}
                      approvalList={getApprovalListRes.data}
                      startDate={params.startDate}
                    />
                  )
                },
                {
                  title: "Drops",
                  name: "drops",
                  content: () => (
                    <ApprovalChangeDropsTab
                      {...props}
                      productApprovalListId={currentApprovalListId}
                    />
                  )
                }
              ]}
            />
          )}
        </TabbedTableWrapper>
      </MainContentWrapper>
    </Layout>
  );
};

export default ApprovalChangeDatesPage;

const TabbedTableWrapper = styled.div`
  ${({ theme }) => css`
    margin-top: ${theme.spacing.margins.xl};
    .page-desc {
      margin-top: ${theme.spacing.margins.lg};
    }
    .table-content {
      margin-top: ${theme.spacing.margins.lg};
    }
  `}
`;
